<div class="p-grid">
    <div class="p-col-12">
        <p-toast></p-toast>
        <div class="card">
            <h5>{{ 'click.titulo' | translate }}</h5>
            <div class="p-fluid p-formgrid p-grid">


                <div class="p-field p-col-12 p-md-4"
                    *ngIf="(perfil != null && (perfil.nmePerfil === 'ADMTIVIT' || perfil.nmePerfil === 'MNGTIVIT' || perfil.nmePerfil === 'OPRTIVIT')) ">
                    <h6>{{ 'click.cedente' | translate }}</h6>
                    <p-autoComplete [(ngModel)]="cedente" [suggestions]="filteredCedentes"
                        (completeMethod)="filterCedentes($event)" field="nmeCedente" [dropdown]="true" id="cedente">
                    </p-autoComplete>
                </div>

                <div class="p-field p-col-12 p-md-4">
                    <h6>{{ 'click.documento' | translate }}</h6>
                    <input id="documentoSacado" type="text" pInputText [(ngModel)]="filterCedente.documentoSacado"
                        maxlength="14" />
                </div>

                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'click.email' | translate }}</h6>
                    <input id="email" type="text" pInputText [(ngModel)]="filterCedente.email" />
                </div>

                <div class="p-field p-col-12 p-md-2">
                    <h6>{{ 'click.datainicial' | translate }}</h6>
                    <span class="p-float-label">
                        <p-calendar [showIcon]="true" inputId="icon" [(ngModel)]="filterCedente.dtaInicial"
                            dateFormat="dd/mm/yy"></p-calendar>
                    </span>
                </div>

                <div class="p-field p-col-12 p-md-2">
                    <h6>{{ 'click.datafinal' | translate }}</h6>
                    <span class="p-float-label">
                        <p-calendar [showIcon]="true" inputId="icon" [(ngModel)]="filterCedente.dtaFinal"
                            dateFormat="dd/mm/yy"></p-calendar>
                    </span>
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <h6>{{ 'click.dtaVencimentoinicial' | translate }}</h6>
                    <span class="p-float-label">
                        <p-calendar [showIcon]="true" inputId="icon" [(ngModel)]="filterCedente.dtaVencimentoInicial"
                            dateFormat="dd/mm/yy"></p-calendar>
                    </span>
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <h6>{{ 'click.dtaVencimentofinal' | translate }}</h6>
                    <span class="p-float-label">
                        <p-calendar [showIcon]="true" inputId="icon" [(ngModel)]="filterCedente.dtaVencimentoFinal"
                            dateFormat="dd/mm/yy"></p-calendar>
                    </span>
                </div>
                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'click.seuNumero' | translate }}</h6>
                    <input id="seuNumero" type="text" pInputText [(ngModel)]="filterCedente.seuNumero" />
                </div>
            </div>
            <button pButton pRipple type="button" label="{{ 'label.pesquisar' | translate }}"
                (click)="pesquisarClickTitulo()" class="p-mr-2"></button>
            <button pButton pRipple type="button" label="{{ 'label.limparformulario' | translate }}"
                (click)="limparFormulario()" class="p-mr-2"></button>
            <!--<button pButton pRipple type="button" label="{{ 'label.exportar' | translate }}" (click)="downloadFile()" class="p-mr-2" *ngIf="historicoEmail != null && historicoEmail.length > 0"></button>-->
            <span *ngIf="historicoEmail != null && historicoEmail.length > 0" class="p-mr-2 p-input-icon-left">
                <p-splitButton label="Exportar" icon="pi pi-clone" [model]="exportOptions"
                    styleClass="p-button-info p-mr-2"></p-splitButton>
            </span>

            <div class="p-col-12" *ngIf="pesquisandoProgress === true">
                {{ 'label.carregando' | translate }}
                <p-progressBar mode="indeterminate" [style]="{'height': '30px'}"></p-progressBar>
            </div>

            <div class="p-col-12">
                <p-table #dt [value]="historicoEmail" dataKey="id" styleClass="p-datatable-customers" [rowHover]="true"
                    [rows]="10" [paginator]="true" [filterDelay]="0" [globalFilterFields]="['nomeCedente', 'nomeSacado','emailSacado','dtaEnvioLink','qtdeClicks',
                     'nossoNumero', 'vlrTitulo']">
                    <ng-template pTemplate="caption">
                        <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                            <h5 class="p-m-0">{{ 'click.historicoemail' | translate }}</h5>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                    placeholder="Global Search" />
                            </span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="nomeCedente">
                                <div class="p-d-flex p-jc-between p-ai-center">
                                    {{ 'click.cedente' | translate }}
                                    <p-sortIcon field="nomeCedente"></p-sortIcon>
                                    <p-columnFilter type="text" field="nomeCedente" display="menu"
                                        class="p-ml-auto"></p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="nomeSacado">
                                <div class="p-d-flex p-jc-between p-ai-center">
                                    {{ 'click.nome' | translate }}
                                    <p-sortIcon field="nomeSacado"></p-sortIcon>
                                    <p-columnFilter type="text" field="nomeSacado" display="menu"
                                        class="p-ml-auto"></p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="emailSacado">
                                <div class="p-d-flex p-jc-between p-ai-center">
                                    {{ 'click.emailsacado' | translate }}
                                    <p-sortIcon field="emailSacado"></p-sortIcon>
                                    <p-columnFilter type="text" field="emailSacado" display="menu"
                                        class="p-ml-auto"></p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="dtaEnvioLink">
                                <div class="p-d-flex p-jc-between p-ai-center">
                                    {{ 'click.dataenvioultimolink' | translate }}
                                    <p-sortIcon field="dtaEnvioLink"></p-sortIcon>
                                    <p-columnFilter type="date" field="dtaEnvioLink" display="menu"
                                        class="p-ml-auto"></p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="dtaEnvioLink">
                                <div class="p-d-flex p-jc-between p-ai-center">
                                    {{ 'click.dtaClickUltimoLink' | translate }}
                                    <p-sortIcon field="dtaClickLink"></p-sortIcon>
                                    <p-columnFilter type="date" field="dtaEnvioLink" display="menu"
                                        class="p-ml-auto"></p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="qtdeClicks">
                                <div class="p-d-flex p-jc-between p-ai-center">
                                    {{ 'click.qtdeClick' | translate }}
                                    <p-sortIcon field="qtdeClicks"></p-sortIcon>
                                    <p-columnFilter type="numeric" field="qtdeClicks" display="menu"
                                        class="p-ml-auto"></p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="nossoNumero">
                                <div class="p-d-flex p-jc-between p-ai-center">
                                    {{ 'click.nossonumero' | translate }}
                                    <p-sortIcon field="nossoNumero"></p-sortIcon>
                                    <p-columnFilter type="numeric" field="nossoNumero" display="menu"
                                        class="p-ml-auto"></p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="nossoNumero">
                                <div class="p-d-flex p-jc-between p-ai-center">
                                    {{ 'click.seuNumero' | translate }}
                                    <p-sortIcon field="seuNumero"></p-sortIcon>
                                    <p-columnFilter type="numeric" field="seuNumero" display="menu"
                                        class="p-ml-auto"></p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="vlrTitulo">
                                <div class="p-d-flex p-jc-between p-ai-center">
                                    {{ 'click.vlrTitulo' | translate }}
                                    <p-sortIcon field="vlrTitulo"></p-sortIcon>
                                    <p-columnFilter type="date" field="vlrTitulo" display="menu"
                                        class="p-ml-auto"></p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="vlrTitulo">
                                <div class="p-d-flex p-jc-between p-ai-center">
                                    {{ 'click.dtaVencimento' | translate }}
                                    <p-sortIcon field="vlrTitulo"></p-sortIcon>
                                    <p-columnFilter type="date" field="dtaVencimento" display="menu"
                                        class="p-ml-auto"></p-columnFilter>
                                </div>
                            </th>
                            <th>
                                <div class="p-d-flex p-jc-between p-ai-center" style="font-weight: bold;">
                                    <i class="pi pi-search" style="color: red;padding-left:20px"></i>
                                </div>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-historico>
                        <tr class="p-selectable-row">
                            <td>
                                <span class="p-column-title"></span>
                                {{historico.nomeCedente}}
                            </td>
                            <td>
                                <span class="p-column-title"></span>
                                {{historico.nomeSacado}}
                            </td>
                            <td>
                                <span class="p-column-title"></span>
                                {{historico.emailSacado}}
                            </td>
                            <td>
                                <span class="p-column-title"></span>
                                {{historico.dtaEnvioLink | date: 'dd/MM/yyyy HH:mm:ss'}}
                            </td>
                            <td>
                                <span class="p-column-title"></span>
                                {{historico.dtaClickLink | date: 'dd/MM/yyyy HH:mm:ss'}}
                            </td>
                            <td>
                                <span class="p-column-title"></span>
                                {{historico.qtdeClicks}}
                            </td>
                            <td>
                                <span class="p-column-title"></span>
                                {{historico.nossoNumero}}
                            </td>
                            <td>
                                <span class="p-column-title"></span>
                                {{historico.seuNumero}}
                            </td>
                            <td>
                                <span class="p-column-title"></span>
                                {{historico.vlrTitulo | currency:'BRL'}}
                            </td>
                            <td>
                                <span class="p-column-title"></span>
                                {{historico.dtaVencimento | date: 'dd/MM/yyyy'}}
                            </td>
                            <!-- <td>
                                <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-warning p-mr-2"
                                    (click)="pesquisarHistoricoClick(historico.id)" alt="Ver Historico de Clicks"></button>
                            </td> -->
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="p-d-flex p-ai-center p-jc-between">
                            {{ 'label.totalde' | translate }} {{historicoEmail ? historicoEmail.length : 0 }} {{
                            'click.clicks' | translate }}.
                        </div>
                    </ng-template>
                </p-table>
            </div>

            <!-- <div class="p-col-12">
                <p-dialog [(visible)]="historicoClickDetalhe" [style]="{width: '500px'}"
                header="{{ 'click.historicoclick' | translate }}" [modal]="true" styleClass="p-fluid">
                    <p-table #dt [value]="historicoClick" dataKey="codHistoricoClick" styleClass="p-datatable-customers" [rowHover]="true"
                        [rows]="10" [paginator]="true" [filterDelay]="0" [globalFilterFields]="['dtaClickLink','dtaEnvio','nroClicks']">
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="dtaClickLink">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        {{ 'click.dtaClickLink' | translate }}
                                        <p-sortIcon field="dtaClickLink"></p-sortIcon>
                                        <p-columnFilter type="date" field="dtaClickLink" display="menu"
                                            class="p-ml-auto"></p-columnFilter>
                                    </div>
                                </th>
                                <th pSortableColumn="dtaEnvio">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        {{ 'click.dataenviolink' | translate }}
                                        <p-sortIcon field="dtaEnvio"></p-sortIcon>
                                        <p-columnFilter type="date" field="dtaEnvio" display="menu"
                                            class="p-ml-auto"></p-columnFilter>
                                    </div>
                                </th>
                                <th pSortableColumn="nroClicks">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        {{ 'click.qtdeClick' | translate }}
                                        <p-sortIcon field="nroClicks"></p-sortIcon>
                                        <p-columnFilter type="numeric" field="nroClicks" display="menu"
                                            class="p-ml-auto"></p-columnFilter>
                                    </div>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-historicoClick>
                            <tr class="p-selectable-row">
                                <td>
                                    <span class="p-column-title"></span>
                                    {{historicoClick.dtaClickLink | date: 'dd/MM/yyyy HH:mm:ss'}}
                                </td>
                                <td>
                                    <span class="p-column-title"></span>
                                    {{historicoClick.dtaEnvio | date: 'dd/MM/yyyy HH:mm:ss'}}
                                </td>
                                <td>
                                    <span class="p-column-title"></span>
                                    {{historicoClick.nroClicks}}
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                {{ 'label.totalde' | translate }} {{historicoClick ? historicoClick.length : 0 }} {{
                                'click.clicks' | translate }}.
                            </div>
                        </ng-template>
                    </p-table>
                    <ng-template pTemplate="footer">
                        <button pButton pRipple label="{{ 'label.cancelar' | translate }}" icon="pi pi-times"
                            class="p-button-text" (click)="hideDetalhesHistoricoClickDialog()"></button>
                    </ng-template>
                </p-dialog>
            </div> -->
        </div>
    </div>
</div>
